export const SPEECH_OUTCOME_CONSTANTS = {
    CELF_5: 'Clinical Evaluation of Language Fundamentals – 5th Edition (CELF-5)',
    CELFP_2: 'Clinical Evaluation of Language Fundamentals, Preschool – 2nd Edition (CELFP-2)',
    CAAP_2: 'Clinical Assessment of Articulation and Phonology, 2nd Edition (CAAP-2)',
    GFTA_3: 'The Goldman-Fristoe Test of Articulation, 3rd Edition (GFTA-3)',
    ROSSETTI_SCALE: 'The Rossetti Infant-Toddler Language Scale',
    FCP_R: 'Functional Communication Profile – Revised (FCP-R)',
  };